import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles/groupsList.css';
import { SERVICE_TYPE } from '../../../../constants/serviceSubscriptions';
import { IGroup } from '../../../../store';
import { Group } from '../Group';

interface IGroupsListPorps {
  groups: IGroup[];
  mailingSection: React.ReactNode;
}

export function GroupsList({ groups, mailingSection }: IGroupsListPorps) {
  return (
    <div className={styles['groups_list']}>
      {groups.map((group, i) => !!group.categories.length && <Group {...group} key={i} />)}
      {mailingSection}
      <Group
        title="Сервисные подписки"
        categoryGroup={SERVICE_TYPE}
        subtitle={
          <UIText2 color="text-secondary-default">
            Согласно{' '}
            <a href="/help/about/rules-natural/" target="_blank">
              нашим правилам
            </a>
            , вы не можете отписаться от следующих рассылок: сервисные сообщения о состоянии лицевого счета, обновление
            условий обслуживания, сообщения от пользователей и от модерации.
          </UIText2>
        }
      />
    </div>
  );
}
